import { erpToast } from 'design-system/components/erp-toast'

const showSuccess = (message: string) => {
 erpToast.success(message)
}

export default showSuccess
